export default __webpack_public_path__ + "static/media/header-person-active.ed96679e.svg";